import React, { useContext, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import {
    removeTrailingZeros,
    setPriceToZeroIfFreebies,
} from '@gumtree/ui-library/src/utils/currency-service';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { GrowthBookFeature } from '@gumtree/shared/src/model/experiment';
import { TextBtn } from '@gumtree/create-order/src/page/create-order-page.style';
import { stickyScroll } from './sticky-scroll';
import type { VipState } from '../../reducers';
import {
    Price,
    BuyStickyHeaderTxtRow,
    BuyStickyHeaderFnRow,
    BuyStickyButtonsContainer,
    BuyStickyHeaderContainer,
} from './style';
import { MotorsCTAContext } from '../../vip-context';
import { BuyButton } from '../seller-buy-block';
import { ExtraPrice, PriceDivider } from '../seller-buy-block/index.style';

const BuyStickyHeader: React.FC<{ setIsBuyerProtectionOpen: (isOpen: boolean) => void }> = ({
    setIsBuyerProtectionOpen,
}) => {
    const {
        device,
        price,
        l2CategoryId,
        deliveryFromPrice,
        buyerProtectionPrice,
        l1CategorySeoName,
    } = useSelector(
        ({
            adDetails: {
                price,
                l2CategoryId,
                deliveryFromPrice,
                buyerProtectionPrice,
                l1CategorySeoName,
            },
            baseConfig: { device },
        }: VipState) => ({
            device,
            price,
            l2CategoryId,
            deliveryFromPrice,
            buyerProtectionPrice,
            l1CategorySeoName,
        }),
        shallowEqual
    );

    const isServices = l1CategorySeoName === 'business-services';
    const isMobile = device.type === 'mobile';
    const isUI_202506 =
        useFeatureValue(GrowthBookFeature.SERVICE_NEW_UI, 'A') === 'B' && isServices;
    const isMotorsCTATask1 = useContext(MotorsCTAContext)?.isMotorsCTATask1;

    useEffect(() => {
        const cleanup = stickyScroll(isMobile, !!isMotorsCTATask1, isUI_202506);
        return cleanup;
    }, [isMobile, isMotorsCTATask1, isUI_202506]);
    
    const renderedPrice = removeTrailingZeros(setPriceToZeroIfFreebies(price, l2CategoryId));

    return (
        <BuyStickyHeaderContainer data-q="sticky-banner">
            <BuyStickyHeaderTxtRow>
                <Price>{renderedPrice}</Price>
                <ExtraPrice style={{ fontWeight: 600 }}>
                    {deliveryFromPrice}
                    <PriceDivider>|</PriceDivider>
                    <TextBtn type="button" onClick={() => setIsBuyerProtectionOpen(true)}>
                        Buyer protection
                    </TextBtn>
                    {buyerProtectionPrice}
                </ExtraPrice>
            </BuyStickyHeaderTxtRow>
            <BuyStickyHeaderFnRow>
                <BuyStickyButtonsContainer>
                    <BuyButton type="buy" />
                    <BuyButton type="collect" />
                </BuyStickyButtonsContainer>
            </BuyStickyHeaderFnRow>
        </BuyStickyHeaderContainer>
    );
};

export default BuyStickyHeader;
